/*
 * @Author: mazhigang
 * @Date: 2023-04-23 10:45:21
 * @LastEditors: mazhigang
 * @LastEditTime: 2023-08-02 11:10:40
 */
import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Message } from "element-ui";

Vue.prototype.$version = "1.0.0";
/*第一层if判断生产环境和开发环境*/
if (process.env.NODE_ENV === "production") {
  /*第二层if，根据.env文件中的VUE_APP_FLAG判断是生产环境还是测试环境*/
  if (process.env.VUE_APP_FLAG === "prod") {
    //production 生产环境
    Vue.prototype.$baseUrl = "http://baoan.shangduyun.com/";
    Vue.prototype.environment = "";
  } else {
    //test 测试环境
    Vue.prototype.$baseUrl = "http://baoan.shangduyun.com/";
    Vue.prototype.environment = "";
  }
} else {
  //dev 开发环境
  Vue.prototype.$baseUrl = "http://baoan.shangduyun.com/";
  Vue.prototype.environment = "/dev-api";
}
const instance = axios.create({
  baseURL: Vue.prototype.environment,
  withCredentials: false,
  responseType: ""
});

instance.interceptors.request.use(
  config => {
    config.headers["x-ba-admin-token"] = localStorage.getItem("TOKEN");
    config.headers.Version = Vue.prototype.$version;
    config.headers["Content-Type"] = "application/json; charset=utf-8";
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  function(response) {
    // 处理响应数据
    if (parseInt(response.data.respCode) !== 0) {
      if (parseInt(response.data.respCode)) {
        if (parseInt(response.data.respCode) == 401) {
          router.push("/login");
        }
        Message({
          message: response.data.respMsg || "Error",
          type: "error",
          duration: 3 * 1000
        });
      } else {
        return response;
      }
      return Promise.reject(response);
    } else {
      return response.data;
    }
  },
  function(error) {
    // 处理响应失败
    return Promise.reject(error);
  }
);

Vue.prototype.$axios = instance;
export default instance;



// WEBPACK FOOTER //
// ./src/api/axios.js